import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowRight } from 'lucide-react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { integrationIdSelector, languageSelector } from '@/state/config';
import { sessionIdSelector, userSelector, webviewModalState, } from '@/state/session';
const FISERV_SALES_URL = 'https://webviews-git-fiserv-mcp-moveo-ai.vercel.app/fiserv/contact-form';
const FISERV_TRIGGER_NODE_ID = 'd51006d1-ad5e-4c19-a5fc-21de2356f392';
const FISERV_TERMS_URL = 'https://www.clover.com/privacy-policy';
export const FiservFooter = ({ children }) => {
    const setWebviewModal = useSetRecoilState(webviewModalState);
    const sessionId = useRecoilValue(sessionIdSelector);
    const integrationId = useRecoilValue(integrationIdSelector);
    const user = useRecoilValue(userSelector);
    const language = useRecoilValue(languageSelector);
    const handleContactSales = () => {
        const params = new URLSearchParams();
        params.set('channel', 'web');
        if (integrationId)
            params.set('integration_id', integrationId);
        if (language)
            params.set('lang', language);
        if (sessionId)
            params.set('session_id', sessionId);
        params.set('trigger_node_id', FISERV_TRIGGER_NODE_ID);
        if (user === null || user === void 0 ? void 0 : user.user_id)
            params.set('user_id', user.user_id);
        setWebviewModal({
            type: 'webview',
            url: `${FISERV_SALES_URL}?${params.toString()}`,
            name: 'Contact sales',
            label: 'Contact sales',
            height: 'compact',
            trigger_node_id: FISERV_TRIGGER_NODE_ID,
            action_id: 'fiserv-contact-sales',
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "bg-bg-muted text-foreground-muted pointer-events-none absolute -top-[28px] z-0 flex w-[calc(100%-24px)] justify-end gap-1 rounded-t-xl border border-border pb-6 pr-4 pt-1.5 text-xs", children: _jsxs("button", { type: "button", onClick: handleContactSales, className: "pointer-events-auto inline-flex cursor-pointer items-center gap-1 text-[var(--color-link)] no-underline hover:underline", children: ["Contact sales", _jsx(ArrowRight, { className: "h-3 w-3" })] }) }), children, _jsxs("p", { className: "text-foreground-muted mt-2 w-full text-center text-[10px]", children: ["By using this chat, you agree to our", ' ', _jsx("a", { href: FISERV_TERMS_URL, target: "_blank", rel: "noreferrer", className: "text-[var(--color-link)] underline", children: "Privacy Notice" }), "."] })] }));
};
